module.exports = __webpack_public_path__ + "static/SL77-6777f0271a941885b8cd32d2fe851fcf.png";